import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { addCaddyShuffle, getCaddyQueue } from '../api/caddyAPI';
import TagCaddyModal from './TagCaddyModal';
import swal from 'sweetalert2';
import NextRoundModal from './NextRoundModal';

const CaddyQueue = (props) => {

    const [selectedDate,                    setSelectedDate]                    = useState(moment().toDate());
    const [queueTable,                      setQueueTable]                      = useState(null);
    const [isInit,                          setIsInit]                          = useState(true);
    const [showShuffleButton,               setShowShuffleButton]               = useState(true);
    const [holiday,                         setHoliday]                         = useState(null);
    const [caddyQueue,                      setCaddyQueue]                      = useState([]);
    const [caddyList,                       setCaddyList]                       = useState([]);
    const [showTagCaddyModal,               setShowTagCaddyModal]               = useState(null);
    const [showNextRoundModal,              setShowNextRoundModal]              = useState(null);

    const history = useHistory()

    useEffect(() => {         
        props.title("Queue", "caddy-queue")
        $('#txtDate').datepicker({
            format: 'dd-mm-yyyy',
            endDate: new Date(),
            autoclose: true,
        });  
        $('#txtDate').on('change', function (event) {
            setSelectedDate(event.target.value)
        }); 
    }, []);

    useEffect(() => {
        fetchCaddyQueue(selectedDate)
    }, [selectedDate])

    const navigateTo = (path) => {
        history.push(path)
    }

    function exportSheet(type) {
        queueTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${moment().format("DD-MM-YYYY")} - Caddy Queue` // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }

    const ShuffleHandler = async () => {
        try {
            await addCaddyShuffle(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
            fetchCaddyQueue(selectedDate)
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    useEffect(() => {
        if (!isInit) fillDataTable();
    }, [caddyQueue])
    
    const fetchCaddyQueue = async(date) => {
        try {
            const {caddyQueue, caddyList, caddyShuffle, holiday} = await getCaddyQueue(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'));
            isInit ? setIsInit(false) : $('#tblCaddyQueue').KTDatatable().destroy(); 
            setShowShuffleButton(caddyShuffle.length == 0)
            setCaddyQueue(caddyQueue)
            setCaddyList(caddyList)
            setHoliday(holiday)
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    function fillDataTable() {

        const dataTable = $('#tblCaddyQueue').KTDatatable({
            data: {
                saveState: false,
                source: caddyQueue,
                pageSize: 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable: true,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Index',
                    title: 'Index',
                    width: 50,
                },
                {
                    field: 'Name',
                    title: 'Name',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                <div class="kt-user-card-v2__pic">
                                    ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="event-thumbail" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info">  ${row.Name.substring(0, 1)}</div>`}
                                </div>
                                <div class="kt-user-card-v2__details text-clip">
                                    <span class="kt-user-card-v2__name text-clip"> ${row.Name} </span> 
                                </div>
                            </div>`
                    },
                    width: 200,
                },
                {
                    field: 'CaddyNumber',
                    title: 'Caddy Number',
                    width: 120,
                },
                {
                    field: 'Mobile',
                    title: 'Mobile',
                    width: 90,
                },
                {
                    field: 'Round',
                    title: 'Round',
                    width: 50,
                    template: function (row) {
                        return `<center> ${row.Round} </center>`
                    }
                },
                {
                    field: 'TagName',
                    title: '',
                    template: function (row) {
                        if (row.TagID == 0) {
                            return `<center>
                                        <span 
                                            class="tag btn btn-sm btn-info" 
                                            title="Tag" type="button"
                                            data-id="${row.ID}">
                                            <i class="fa fa-tag margin-l3"></i>
                                        </span>
                                    </center >`;
                        } else {
                            return `<center>
                                        <span 
                                        class="tag btn btn-sm  
                                        ${row.TagType == 'Member' ? 'btn-success' : 'btn-warning text-white'} " 
                                        title="Tag" data-id="${row.ID}" 
                                        type="button" >
                                            ${row.TagName}
                                        </span>
                                   </center>`;
                        }
                    }
                },
            ]
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblCaddyQueue .kt-datatable__table').addClass('overflow-x-auto');

        $('#tblCaddyQueue').on('click', '.tag', function () {
            const dataId = this.getAttribute('data-id');
            setShowTagCaddyModal(dataId)
        });
        
        // export to excel
        const QueueTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Caddy Queue`,
        });
        setQueueTable(QueueTable);
        $('.tableexport-caption').addClass('hidden');
    }

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-b0" id="kt_content" style={{paddingTop: "0px"}}>
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__body kt-portlet__body--fit padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 border-bottom-light" role="form">
                                <div className="row">

                                    <label className="col-form-label col-sm-1 text-right">Date </label>
                                    <div className="form-group col-xl-2 col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtDate" 
                                                name="txtDate" 
                                                type="text" 
                                                className="form-control" 
                                                defaultValue={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                placeholder="Select date" />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group col-xl-3 col-sm-3">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input type="text" className="form-control clientSearch" placeholder="Search Caddy..." id="generalSearch" />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                        </div>
                                    </div>

                                    <div id="exportContainer" className="form-group col-xl-1 col-sm-1 vertical-center">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group col-xl-5 col-sm-5 vertical-center justify-content-start">
                                        <span id="btnAttendance" className="btn btn-warning  btn-sm margin-r5 text-white" onClick={() => navigateTo('/caddy-attendance')}><i className="fa fa-angle-left"></i>Caddy Attendance  </span>
                                        <span id="btnAddToNext" className="btn btn-brand  btn-sm margin-r5" data-toggle="modal" onClick={() => setShowNextRoundModal(true)} data-target="#modalRound"><i className="fa fa-plus"></i>Add for next round  </span>
                                        {showShuffleButton && (
                                            <span id="btnShuffle" name="btnShuffle" type="button" className="btn btn-sm btn-success margin-r5" onClick={ShuffleHandler}><i className="fa fa-random"></i>Shuffle</span>
                                        )}
                                    </div>

                                </div>
                                {holiday && (
                                    <div className="row">
                                        <div className="form-group col-sm-12 vertical-center mb-1">
                                            <h6 className="text-center text-danger mb-0"><span id="lblHoliday">Bank Holiday: {holiday.Name}</span></h6>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div id="tblCaddyQueue" className="kt-datatable table-striped "></div>
                        </div>
                    </div>
                </div>
            </div>
            {showTagCaddyModal && (
                <TagCaddyModal
                    show={showTagCaddyModal}
                    fetchCaddyQueue={() => fetchCaddyQueue(selectedDate)}
                    caddyQueue={caddyQueue.find(q => q.ID == showTagCaddyModal)}
                    onDismissModal={() => setShowTagCaddyModal(null)}
                />
            )}
            {showNextRoundModal && (
                <NextRoundModal
                    show={showNextRoundModal}
                    caddyList={caddyList}
                    selectedDate={moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD')}
                    fetchCaddyQueue={() => fetchCaddyQueue(selectedDate)}
                    onDismissModal={() => setShowNextRoundModal(false)}
                />
            )}
        </>
    )
}

export default CaddyQueue